var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clock"}},[_c('span',{staticClass:"date"},[_vm._v("乐程机动车驾驶员计时数据平台")]),_c('span',{staticClass:"date2"},[_vm._v(_vm._s(_vm.date + " " + _vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }